<template>
  <div class="color-block" :class="classes">
    <span class="sr-only">{{score}}</span>
  </div>
</template>

<script>
export default {
  name: 'color-block',
  props: ['score', 'name', 'ishovered'],
  data() {
    return {
      classList: ['none', 'one', 'two', 'three', 'four', 'five', 'six'],
    };
  },
  computed: {
    colorClass() {
      const color = this.score === null ? 'none' : this.classList[this.score];
      return color;
    },
    classes() {
      if (this.ishovered) {
        return `${this.colorClass} active`;
      }
      return this.colorClass;
    },
  },
};
</script>

<style lang="less">
  .active {
    box-shadow: 1px 1px 5px rgba(34, 34, 34, 0.5);
    &.none {
      box-shadow: none;
    }
  }
  .color-block {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    transition: background-color .5s ease-in-out;
  }
</style>



// WEBPACK FOOTER //
// MapColorBlock.vue?5e5dd4e7